export default __webpack_public_path__ + "static/media/arrow-right.efbe56d6.svg";